import type { ReactElement } from 'react';

import { Box, Flex, Text } from '@rango-dev/whale';
import BigNumber from 'bignumber.js';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useAppSelector } from '../hooks/reduxHooks';
import { numberToString } from '../utils/Numbers';

import styles from './Analytics.module.css';

export function Analytics(): ReactElement {
  const status = useAppSelector((state) => state.status.status);
  const { t } = useTranslation();
  if (!status) {
    return <React.Fragment />;
  }

  return (
    <Flex
      direction="row"
      align="center"
      width="fit-content"
      ml="24px"
      px="16px"
      py="8px"
      className={styles.container}>
      <Box mr="8px" width="24px">
        <img src="/imgs/logos/whatshot.svg" width={24} height={24} />
      </Box>
      <Flex direction="column">
        <Text size="2" color="gray" className={styles.label}>
          {t('Total trade volume')}:&nbsp;
        </Text>
        <Text size="3" weight="bold" color="gray">
          {numberToString(new BigNumber(status.totalSwapInUsd))}$
        </Text>
      </Flex>
    </Flex>
  );
}
